import Icon from "@ui-kit/icons/Icon.web";
import React from "react";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { AlertType, AlertSize } from "../alert-types";

const alertPaintMapBackground = {
  info: "var(--chakra-colors-primary-200)",
  error: "var(--chakra-colors-secondary-200)",
  warning: "var(--chakra-colors-yellow-200)",
  success: "var(--chakra-colors-green-100)",
};

const alertPaintMapIcon = {
  info: "var(--chakra-colors-primary-800)",
  error: "var(--chakra-colors-secondary-800)",
  warning: "var(--chakra-colors-yellow-800)",
  success: "var(--chakra-colors-green-900)",
};

const getIcon = (status: AlertType, size: AlertSize) => {
  const boxSize = size === "sm" ? "18px" : "24px";
  if (status === "error") {
    return <Icon.Error boxSize={boxSize} colorPalette="currentColor" />;
  }

  if (status === "warning") {
    return <Icon.Warning boxSize={boxSize} colorPalette="currentColor" />;
  }

  return <Icon.Info boxSize={boxSize} colorPalette="currentColor" />;
};

export type ToastAlertProps = {
  status: AlertType;
  title: React.ReactElement | string;
  size?: "sm" | "md";
  icon?: React.ReactElement;
  isTransparent?: boolean;
};

const StaticAlert = ({
  status,
  title,
  size = "md",
  icon,
  isTransparent = false,
}: ToastAlertProps): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      backgroundColor={
        isTransparent ? "transparent" : alertPaintMapBackground[status]
      }
      paddingY="sm"
      height={size === "sm" ? "36px" : "56px"}
      sx={{
        "& .chakra-icon": {
          color: alertPaintMapIcon[status],
        },
      }}
    >
      {icon || getIcon(status, size)}
      <Box display="flex" flexDirection="column" fontSize="md" paddingLeft="md">
        <Text color="var(--clr-font-dark)" as="span">
          {title}
        </Text>
      </Box>
    </Box>
  );
};

export default StaticAlert;
